import React, { useState } from "react";
import { connect } from "react-redux";
import { useRequiredAuth } from "../../common/guard/requiredAuth";
import { getFieldMetadata } from "../../../store/reporting/actions";
import ReportBuilder from "../components/ReportBuilder";
import { List, ListItemButton, ListItemText, Typography } from "@mui/material";
import ReportingOrgStructure from "./ReportingOrgStructure";

const REPORT_MODULES = [
  {
    label: "Organization Structure",
    key: "ORG",
  },
  {
    label: "Customized Report",
    key: "CR",
  },
];

const Report = (props) => {
  const { user, loading, getFieldMetadata } = props;
  const { hasPermissions } = useRequiredAuth();
  const isForOversight = hasPermissions([
    "IS_ADMIN",
    "CAN_ACCESS_OVERSIGHT_REPORTING",
  ]);
  const [fields, setFields] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [selectedModule, setSelectedModule] = React.useState({
    label: "Customized Report",
    key: "CR",
  });
  const handleListItemClick = (event, thisModule) => {
    setSelectedModule(thisModule);
  };

  return (
    <>
      <div className="container-fluid py-3">
        <div class="row">
          <div class="col-3">
            <div className="border rounded elevated p-4">
              <Typography
                variant="h5"
                component="header"
                className="font-weight-bold mb-2"
              >
                Reporting Modules
              </Typography>

              <List
                component="nav"
                aria-label="list of module available for reports"
              >
                {REPORT_MODULES.map((module) => (
                  <ListItemButton
                    selected={selectedModule?.key === module.key}
                    onClick={(event) => handleListItemClick(event, module)}
                    key={module.key}
                  >
                    <ListItemText primary={module.label} />
                  </ListItemButton>
                ))}
              </List>
            </div>
          </div>

          <div class="col-9">
            <div className="border rounded elevated p-4">
              {selectedModule?.key === "CR" && <ReportBuilder />}
              {selectedModule?.key === "ORG" && <ReportingOrgStructure />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = ({ user, loading }) => {
  return { user, loading };
};

export default connect(mapStateToProps, {
  getFieldMetadata,
})(Report);
